import {ApiGet} from '../../../shared/services/api-service';
import ftosCommitTypes from './commit-types';
import {normazileTaskResponses} from "../../../shared/services/utils/tasks";

const ftoTasksActions = {
  fetchFtoTaskResponses() {
    return (dispatch) => {
      return ApiGet(`/api/v1/tasks-to-fto-acknowledge`)
        .then((taskResponses) => {
          dispatch({
            type: ftosCommitTypes.SET_MY_TASK_RESPONSES,
            myTaskResponses: normazileTaskResponses(taskResponses)
          })
        })
    }
  },

  fetchFtocTaskResponses() {
    return (dispatch) => {
      return ApiGet(`/api/v1/tasks-to-ftoc-acknowledge`)
        .then((taskResponses) => {
          dispatch({
            type: ftosCommitTypes.SET_MY_TASK_RESPONSES,
            myTaskResponses: normazileTaskResponses(taskResponses)
          })
        })
    }
  },
};

export default ftoTasksActions;
